import { lazy } from 'react';

const CUSTOM_COMPONENTS = {
  CantGoOn: lazy(() => import(/* webpackChunkName: "custom-core" */ './Custom/CantGoOn')),
  DonationCard: lazy(
    () => import(/* webpackChunkName: "custom-donation" */ './Custom/DonationCard'),
  ),
  ThreeStackDecoration: lazy(
    () => import(/* webpackChunkName: "custom-core" */ './Custom/ThreeStackDecoration'),
  ),
  TwoGirl: lazy(() => import(/* webpackChunkName: "custom-core" */ './Custom/TwoGirl')),
  Hero: lazy(() => import(/* webpackChunkName: "custom-core" */ './Custom/MainHero')),
  OurMission: lazy(
    () => import(/* webpackChunkName: "custom-mission" */ './Custom/mission/OurMission'),
  ),
  Video: lazy(() => import(/* webpackChunkName: "custom-core" */ './Custom/Video')),
  DownloadFundraisingGuideColumn: lazy(
    () =>
      import(
        /* webpackChunkName: "custom-fundraising" */ './Custom/fundraising/DownloadFundraisingGuideColumn'
      ),
  ),
  BucketList: lazy(
    () =>
      import(
        /* webpackChunkName: "custom-fundraising" */ './Custom/fundraising/FundraisingBucketList'
      ),
  ),
  DonationHero: lazy(
    () => import(/* webpackChunkName: "custom-donation" */ './Custom/donation/DonationHero'),
  ),
  QuestionsFromOurCommunity: lazy(
    () =>
      import(
        /* webpackChunkName: "custom-donation" */ './Custom/donation/QuestionsFromOurCommunity'
      ),
  ),
  Advocacy_MedicalHistory: lazy(
    () => import(/* webpackChunkName: "custom-advocacy" */ './Custom/advocacy/MedicalHistory'),
  ),
  Advocacy_Resolution: lazy(
    () => import(/* webpackChunkName: "custom-advocacy" */ './Custom/advocacy/AdvocateResolution'),
  ),
  Advocacy_BasedOutsideTheUS: lazy(
    () => import(/* webpackChunkName: "custom-advocacy" */ './Custom/advocacy/BasedOutsideTheUs'),
  ),
  FundraisingIdeas: lazy(
    () =>
      import(/* webpackChunkName: "custom-fundraising" */ './Custom/fundraising/FundraisingIdeas'),
  ),
  YourStoryForm: lazy(
    () => import(/* webpackChunkName: "custom-story" */ './Custom/story/YourStoryForm'),
  ),
  Donate_RealProgress: lazy(
    () => import(/* webpackChunkName: "custom-donation" */ './Custom/donation/RealProgress'),
  ),
  Partnerships_SkinTastic: lazy(
    () => import(/* webpackChunkName: "custom-partner" */ './Custom/partner/PartnersCarousel'),
  ),
  Partnerships_Form: lazy(
    () => import(/* webpackChunkName: "custom-partner" */ './Custom/partner/Partners_Form'),
  ),
  RiseUp_Video: lazy(
    () => import(/* webpackChunkName: "custom-riseup" */ './Custom/riseup/RiseUp_Video'),
  ),
  RiseUp_Letter: lazy(
    () => import(/* webpackChunkName: "custom-riseup" */ './Custom/riseup/RiseUp_Letter'),
  ),
  Report_DoctorGuideForm: lazy(
    () => import(/* webpackChunkName: "custom-report" */ './Custom/report/Report_DoctorGuideForm'),
  ),
  Report_SignPetitionForm: lazy(
    () => import(/* webpackChunkName: "custom-report" */ './Custom/report/Report_SignPetitionForm'),
  ),
  Report_PressKitForm: lazy(
    () => import(/* webpackChunkName: "custom-report" */ './Custom/report/Report_PressKitForm'),
  ),
  Report_Regulatory: lazy(
    () => import(/* webpackChunkName: "custom-report" */ './Custom/report/Report_Regulatory'),
  ),
  Research_Checklist: lazy(
    () => import(/* webpackChunkName: "custom-research" */ './Custom/research/Research_Checklist'),
  ),
  Research_NothingChanges: lazy(
    () =>
      import(/* webpackChunkName: "custom-research" */ './Custom/research/Research_NothingChanges'),
  ),
  Research_Video: lazy(
    () => import(/* webpackChunkName: "custom-research" */ './Custom/research/Research_Video'),
  ),
};

const CUSTOM_CHUNK_PRELOADERS = {
  core: () => import(/* webpackChunkName: "custom-core" */ './Custom/MainHero'),
  donation: () =>
    import(/* webpackChunkName: "custom-donation" */ './Custom/donation/DonationHero'),
  mission: () => import(/* webpackChunkName: "custom-mission" */ './Custom/mission/OurMission'),
  report: () =>
    import(/* webpackChunkName: "custom-report" */ './Custom/report/Report_DoctorGuideForm'),
  research: () =>
    import(/* webpackChunkName: "custom-research" */ './Custom/research/Research_Video'),
  riseup: () => import(/* webpackChunkName: "custom-riseup" */ './Custom/riseup/RiseUp_Video'),
  story: () => import(/* webpackChunkName: "custom-story" */ './Custom/story/YourStoryForm'),
  partner: () =>
    import(/* webpackChunkName: "custom-partner" */ './Custom/partner/PartnersCarousel'),
  fundraising: () =>
    import(/* webpackChunkName: "custom-fundraising" */ './Custom/fundraising/FundraisingIdeas'),
  advocacy: () =>
    import(/* webpackChunkName: "custom-advocacy" */ './Custom/advocacy/MedicalHistory'),
};

const ROUTE_CUSTOM_CHUNKS = {
  '/': ['core', 'donation'],
  '/mission/': ['mission'],
  '/donate/': ['donation'],
  '/report/': ['report'],
  '/research/': ['research'],
  '/rise-up/': ['riseup'],
  '/story/': ['story'],
  '/partner/': ['partner'],
  '/fundraising/': ['fundraising'],
  '/advocate/': ['advocacy'],
};

const normalizeRoutePath = (pathname) => {
  const route = String(pathname || '').replace(/^\/+|\/+$/g, '');
  return route ? `/${route}/` : '/';
};

export const getCustomComponent = (componentName) => CUSTOM_COMPONENTS[componentName] ?? null;

export const getCustomComponentChunksForPath = (pathname) =>
  ROUTE_CUSTOM_CHUNKS[normalizeRoutePath(pathname)] ?? [];

export const preloadCustomComponentsForPath = (pathname) =>
  Promise.all(
    getCustomComponentChunksForPath(pathname).map((chunkName) =>
      CUSTOM_CHUNK_PRELOADERS[chunkName](),
    ),
  );
